// extracted by css-extract-rspack-plugin
export default {"form":"L7c04_YoZ7gBRbbX","info":"r9NJ3COqWocEi90n"};